import { render, staticRenderFns } from "./Theory.vue?vue&type=template&id=176dde14&"
import script from "./Theory.vue?vue&type=script&lang=ts&"
export * from "./Theory.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports